import React, { useEffect, useRef } from "react";

const SetupWizardIframe = () => {
  const iframeRef = useRef(null);
  const host = window.location.hostname;
  const key = Object.keys(sessionStorage).find(k =>
    k.startsWith("oidc.user:")
  );
  const userData = key ? JSON.parse(sessionStorage.getItem(key)) : null;
  const groupId = userData?.profile?.group_id ?? localStorage.getItem("groupId");

  const WATCHED_KEYS = [
    "currentPropertyId",
    "groupId",
    "timeZone",
    "service_provider",
    "isVoucherEngine",
    "email",
  ];

  const sendData = () => {
    iframeRef.current?.contentWindow?.postMessage(
      {
        type: "Data_loaded",
        currentPropertyId: localStorage.getItem("currentPropertyId"),
        email: localStorage.getItem("email"),
        groupId: groupId,
        isVoucherEngine: localStorage.getItem("isVoucherEngine"),
        timeZone: localStorage.getItem("timeZone"),
        serviceProvider: localStorage.getItem("service_provider"),
      },
      "*"
    );
  };

  let onboardAppUrl = "";

  if (host.includes("myma.ai")) {
    onboardAppUrl = process.env.REACT_APP_ONBOARD_APP_URL_MYMA;
  } else if (host.includes("bookmebob.com")) {
    onboardAppUrl = process.env.REACT_APP_ONBOARD_APP_URL_BOOKMEBOB;
  } else if (host.includes("concierge.synxis.com")) {
    onboardAppUrl = process.env.REACT_APP_ONBOARD_APP_URL_SYNXIS;
  } else {
    throw new Error(`Unsupported host: ${host}`);
  }

  const contextParams = new URLSearchParams({
    pid: localStorage.getItem("currentPropertyId") || "",
    gid: groupId || "",
    email: localStorage.getItem("email") || "",
    tz: localStorage.getItem("timeZone") || "",
    sp: localStorage.getItem("service_provider") || "",
    ive: localStorage.getItem("isVoucherEngine") || "",
  }).toString();

  useEffect(() => {
    const handleMessage = (event) => {
      if (event.data.type === "IFRAME_READY") {
        sendData();
      }
      if (event.data.type === "NAVIGATE_TO_DASHBOARD") {
        window.location.href = "https://app.concierge.synxis.com/app/welcome";
      }
    };

    window.addEventListener("message", handleMessage);

    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, []);

  useEffect(() => {
    let lastSnapshot = WATCHED_KEYS.map((k) => localStorage.getItem(k)).join("|");

    const intervalId = setInterval(() => {
      const currentSnapshot = WATCHED_KEYS.map((k) => localStorage.getItem(k)).join("|");
      if (currentSnapshot !== lastSnapshot) {
        lastSnapshot = currentSnapshot;
        sendData();
      }
    }, 400);

    return () => clearInterval(intervalId);
  }, []);


  return (
    <div className="content-area">
      <iframe
        ref={iframeRef}
        src={`${onboardAppUrl}/?module=onboard&${contextParams}`}
        title="Setup Wizard"
        style={{
          width: "93vw",
          height: "95vh",
          border: "none",
          position: "fixed",
          margin: "-58px",
          marginTop: "-23px",
        }}
      />
    </div>

  );
}

export default SetupWizardIframe;

// import React, { useEffect, useRef } from "react";

// const SetupWizardIframe = () => {
//   const iframeRef = useRef(null);

//   useEffect(() => {
//     const sendData = () => {
//       const userData = getAccessToken();
//       const { currentPropertyId, groupId } = getLocalData();

//       iframeRef.current?.contentWindow?.postMessage(
//         {
//           type: "AUTH_TOKEN",
//           token: userData?.token,
//           username: userData?.username,
//           currentPropertyId,
//           groupId,
//         },
//         "http://localhost:5173"
//       );
//     };

//     const handleMessage = (event) => {
//       if (event.origin !== "http://localhost:5173") return;

//       if (event.data?.type === "IFRAME_READY") {
//         sendData();
//       }
//     };

//     window.addEventListener("message", handleMessage);

//     return () => {
//       window.removeEventListener("message", handleMessage);
//     };
//   }, []);

//   const getAccessToken = () => {
//     const key = Object.keys(sessionStorage).find((k) =>
//       k.startsWith("oidc.user:")
//     );

//     if (!key) return null;

//     const data = sessionStorage.getItem(key);
//     if (!data) return null;

//     try {
//       const parsed = JSON.parse(data);
//       return {
//         token: parsed.access_token,
//         username: parsed.profile?.name,
//       };
//     } catch (e) {
//       return null;
//     }
//   };

//   const getLocalData = () => {
//     const currentPropertyId = localStorage.getItem("currentPropertyId");
//     const groupId = localStorage.getItem("groupId");

//     console.log("currentPropertyId:", { currentPropertyId, groupId });

//     return {
//       currentPropertyId,
//       groupId,
//     };
//   };

//   return (
//     <div className="content-area">
//       <iframe
//         ref={iframeRef}
//         src="http://localhost:5173?embed=true"
//         title="Setup Wizard"
//         style={{
//           width: "90vw",
//           height: "93vh",
//           border: "none",
//           position: "fixed",
//           margin: "-58px",
//           marginTop: "-23px",
//         }}
//       />
//     </div>
//   );
// };

// export default SetupWizardIframe;

// --------------
// Old One --

// import React, { Fragment, useState, useEffect } from "react";
// import {
//     Row, Button, Card,
//     CardBody, CustomInput,
//     FormGroup,
//     Label,
//     InputGroupAddon,
//     InputGroupText,
//     Input,
//     InputGroup,
//     CardTitle
// } from "reactstrap";
// import { ChromePicker } from 'react-color';
// import classnames from "classnames";
// import { injectIntl } from 'react-intl';
// import { connect } from 'react-redux';
// import { Colxx } from "../../../../components/common/CustomBootstrap";
// import { NotificationManager } from "../../../../components/common/react-notifications";
// import { API_CopyTemplate_Integration, API_Ingetration_Channels, API_External_Source, gAPI_Internal_Property_By_Id, gAPI_DynmicQuestionSetsTemplate, postAPI_Create_QuestionSet, postAPI_OnboardSetUPWizard, postAPI_createWizardsSteps, gAPI_OnboardSessionStatus, gAPI_WizardSteps, putAPI_Update_OnboardSession } from "../../../../constants/APIs";
// import { AxiosAPI, getGroupID } from "../../../../helpers/AxiosAPI";
// import { setBackGroundColor } from '../integration/style/DigitalAssistantStyle';
// import sync_template from '../../../../assets/Sync_myma.png';
// import AiVoiceChannel from './components/AiVoiceChannel';
// import AiEmailAssistant from './components/AiEmailAssistant';
// import BusinessProfile from './components/BusinessProfile';
// import AvailableProduct from './components/AvailableProduct';
// import SynXisIntegration from './components/SynXisIntegration';
// import HideStat_topic from "./components/Hidestat_topic";
// import wizard from "../../../../assets/theme1.png";
// import wizardIntro from "../../../../assets/theme2.png";
// import email_icon from "../../../../assets/email_con.png";
// import widget from "../../../../assets/widget_icon.png";
// import voice from "../../../../assets/voice_icon.png";
// import social_icon from "../../../../assets/social_icon.png";
// import SyncRoom_Hotel from "./components/SyncRoom_Hotel";
// import { FaSpinner } from "react-icons/fa";
// import { FaCheck } from "react-icons/fa";

// const fromPropertyId = process.env.REACT_APP_COPILOT_PROPERTY_ID;
// const fromGroupId = process.env.REACT_APP_COPILOT_GROUP_ID;
// const defaultWidgetSettings = {
//     isWeb: false,
//     isMessengerX: false,
//     isAssistantMenu: false,
//     isHelpItem: false,
//     isForm: false,
//     isFAQ: false,
//     isConversationFlow: false,
//     messengerTheme: "",
//     dynamicFlowId: null,
// };
// const STEPS = [
//     // { key: "intro", label: "Introduction" },
//     { key: "businessProfile", label: "Verify Business Details" },
//     { key: "availableProduct", label: "Select Products" },
//     { key: "synxisIntegration", label: "Add SynXis Integration" },
//     { key: "syncHotel", label: "Sync Hotel Description" },
//     { key: "bookingAgent", label: "Booking Agent" },
//     { key: "aiVoice", label: "Voice Agent" },
//     { key: "emailAssistant", label: "Email Automation" },
//     { key: "hidestate_topic", label: "Insights" },
//     { key: "thankyou", label: "Summary" },
// ];
// const STEP_NAME_MAP = {
//     "business-details": "businessProfile",
//     "select-products": "availableProduct",
//     "synxis-integration": "synxisIntegration",
//     "sync-description": "syncHotel",
//     "booking-agent": "bookingAgent",
//     "voice-agent": "aiVoice",
//     "email-automation": "emailAssistant",
//     "insights": "hidestate_topic"
// };

// function Templates({ propertyId, locale, email, userName }) {

//     const [apiTemplate, setApiTemplate] = useState("default");
//     const [step, setStep] = useState("intro");

//     const [templateData, setTemplateData] = useState({
//         fromGroupId,
//         fromPropertyId,
//         toPropertyId: propertyId,
//         toGroupId: getGroupID(),
//         isForm: true,
//         isHelpItem: true,
//         isWeb: true,
//         isMessengerX: true,
//         isAssistantMenu: true,
//         isFAQ: false,
//         isMessengerGroupX: false,
//         isEmail: false,
//         isAiVoice: false,
//         isConversationFlow: true,
//         dynamicFlowId: null,
//         messengerTheme: "WebWidgetMenus",
//         appearance: null,
//     });

//     const [appearanceData, setAppearanceData] = useState({
//         primaryColor: "#424344",
//         staticColor: "#000",
//         contrastColor: "white"
//     });
//     let [iseditMode, setEditMode] = useState({ primaryColor: false, staticColor: false, });
//     const [edit, setEdit] = useState(true);
//     const [error, setError] = useState(true);
//     const [dynamicList, setDynamicList] = useState([]);
//     const [assistantList, setAssistantList] = useState([]);
//     const [isSuccess, setIsSuccess] = useState(false);
//     const [assistantId, setAssistantId] = useState('');
//     const [open, setOpen] = useState(false);
//     const [msg, setMsg] = useState([]);
//     const [propertyData, setPropertyData] = useState(null);
//     const [propertyLanguages, setPropertyLanguages] = useState([]);
//     const [sabreIntegration, setSabreIntegration] = useState(undefined);
//     const [synxisData, setSynxisData] = useState(null);
//     const [isCreatingSession, setIsCreatingSession] = useState(false)
//     const [voiceAgentId, setVoiceAgentId] = useState(null);
//     const [id, setid] = useState(null);
//     const [stepStatusMap, setStepStatusMap] = useState({});
//     const [creationOption, setCreationOption] = useState(null);
//     const [showBookingConfig, setShowBookingConfig] = useState(false);
//     const [hasChanged, setHasChanged] = useState(false);
//     const [bookingAgentCreated, setBookingAgentCreated] = useState(false);
//     const [emailIid, setEmailIid] = useState('')
//     const [emailAutomationOption, setEmailAutomationOption] = useState(null);
//     const isUpdatedBookingAgent = stepStatusMap?.bookingAgent === "UpdatedOrCreated";
//     useEffect(() => {
//         if (!propertyId || propertyId === "-1") return;

//         const loadIntegrations = async () => {
//             try {
//                 const propertyRes = await AxiosAPI({
//                     method: "get",
//                     url: `${gAPI_Internal_Property_By_Id}/${propertyId}?group_id=${getGroupID()}`,
//                 });
//                 if(propertyRes.data){
//                     setPropertyData(propertyRes.data)
//                 }

//                 if (propertyRes.data?.languages?.length > 0) {
//                     setPropertyLanguages(propertyRes.data.languages);
//                 }
//                 const integrationRes = await AxiosAPI({
//                     method: "post",
//                     url: `${API_Ingetration_Channels}?group_id=${getGroupID()}`,
//                     data: { channels: ["Sabre"] },
//                 });

//                 const sabre = integrationRes.data.filter(
//                     (k) =>
//                         k.channel === "Sabre" &&
//                         k.disabled === false &&
//                         k.properties.includes(propertyId)
//                 );

//                 setSabreIntegration(sabre.length > 0 ? sabre[0] : undefined);

//             } catch (error) {
//                 console.error("Failed to load Sabre / languages", error);
//             }
//         };

//         loadIntegrations();

//     }, [propertyId]);
//     useEffect(() => {
//         AxiosAPI({
//             method: 'get',
//             url: `${gAPI_DynmicQuestionSetsTemplate}/?propertyId=${fromPropertyId}&groupId=${fromGroupId}&lang=${locale}`,
//         })
//             .then((res) => {
//                 const setlist = res.data.sets.map((set) => ({
//                     ...set,
//                     showMore: false,
//                 }));

//                 const sortedList = setlist.sort(
//                     (a, b) => a.displayOrder - b.displayOrder
//                 );
//                 setDynamicList(sortedList);
//                 const list = sortedList
//                     .filter(
//                         (l) =>
//                             l.type === 'DynamicConversationFlow' &&
//                             l.openAiAssistantId !== ''
//                     )
//                     .map((l) => ({
//                         id: l.id,
//                         name: l.name,
//                         openAiAssistantId: l.openAiAssistantId,
//                     }));

//                 setAssistantList(list);
//             })
//             .catch((err) => {
//                 console.error(
//                     'API error:',
//                     err.response ? err.response.data : err.message
//                 );
//             });
//     }, [fromPropertyId, fromGroupId, locale]);

//     useEffect(() => {
//         if (templateData.messengerTheme === "WebWidgetMenus") {
//             setTemplateData(prev => ({
//                 ...prev,
//                 isHelpItem: true,
//             }));
//         } else if (templateData.messengerTheme === "ChatSuggestions") {
//             setTemplateData(prev => ({
//                 ...prev,
//                 isHelpItem: false,
//             }));
//         }
//     }, [templateData.messengerTheme]);
//     const LoadData = () => {
//         AxiosAPI({
//             method: 'get',
//             url: `${API_External_Source}?groupId=${getGroupID()}&propertyId=${propertyId}`,
//         }).then((res) => {
//             const data = res.data;
//             const synxisItem = data.find((item) => item.sourceType === 'SynXis');

//             if (synxisItem) {
//                 setSynxisData(synxisItem);
//             }

//         });
//     };
//     useEffect(() => {
//         LoadData();
//     }, [propertyId]);

//     const updateTemplateData = (key, value) => {
//         console.log('id', value)
//         setTemplateData(prev => ({ ...prev, [key]: value }));
//         setHasChanged(true);
//     };
//     const handleAddDocument = async (inputData) => {
//         try {
//             const res = await AxiosAPI({
//                 method: "post",
//                 url: API_External_Source,
//                 data: inputData,
//             });

//             if (res.data?.HttpStatusCode === 400) {
//                 setMsg(res.data.Messages || []);
//                 setOpen(true);
//                 return;
//             }
//             LoadData();
//             setIsSuccess(true);
//             NotificationManager.success("SynXis saved successfully", "", 3000);

//         } catch (error) {
//             NotificationManager.error("Save failed", "", 3000);
//             console.error(error);
//         }
//     };
//     const getWizardSteps = async (sessionId) => {
//         try {

//             const res = await AxiosAPI({
//                 method: "get",
//                 url: `${gAPI_WizardSteps}/${sessionId}/steps`
//             });

//             if (!res.data) return;

//             const map = {};

//             res.data.forEach(step => {

//                 const mappedKey = STEP_NAME_MAP[step.stepName];
//                 if (mappedKey) {
//                     map[mappedKey] = step.status;
//                 }
//             });

//             setStepStatusMap(map);
//             const allStepsDone = Object.keys(STEP_NAME_MAP).every(stepName => {
//                 const mappedKey = STEP_NAME_MAP[stepName];
//                 return map[mappedKey] === "UpdatedOrCreated";
//             });

//             if (allStepsDone) {
//                 setStep("thankyou");
//             } else {
//                 const firstIncompleteStep = STEPS.find(
//                     s => map[s.key] !== "UpdatedOrCreated"
//                 );

//                 if (firstIncompleteStep) {
//                     setStep(firstIncompleteStep.key);
//                 }
//             }
//             await checkAndCompleteSession(res.data);

//         } catch (error) {
//             console.error("Failed to fetch wizard steps", error);
//         }
//     };
//     const createWizardSteps = async (payload) => {
//         try {
//             const res = await AxiosAPI({
//                 method: 'post',
//                 url: postAPI_createWizardsSteps,
//                 data: payload
//             })
//             return res.data
//         } catch (error) {
//             console.error("Failed to create wizard steps", error);
//             NotificationManager.error("", "Failed to create wizard steps", 3000);
//             return null;

//         }
//     }
//     const getOnboardSession = async () => {
//         try {

//             const res = await AxiosAPI({
//                 method: "get",
//                 url: `${gAPI_OnboardSessionStatus}?groupId=${getGroupID()}&propertyId=${propertyId}`
//             });

//             if (res.data && res.data.id) {

//                 setid(res.data.id);

//                 if (res.data.sessionStatus === "InProgress") {
//                     getWizardSteps(res.data.id);
//                 }
//                 else if (res.data.sessionStatus === "Completed") {
//                     await getWizardSteps(res.data.id);
//                     setStep("thankyou");
//                 }

//             }
//         } catch (error) {

//             console.error("Failed to fetch session", error);
//             setStep("intro");

//         }
//     };
//     const createOnboardSession = async () => {
//         try {
//             const payload = {
//                 groupId: getGroupID(),
//                 propertyId: propertyId,
//                 sessionStatus: "InProgress",
//                 creator: userName
//             };

//             const res = await AxiosAPI({
//                 method: "post",
//                 url: postAPI_OnboardSetUPWizard,
//                 data: payload
//             });
//             return res.data;

//         } catch (error) {
//             console.error("Failed to create onboard session", error);
//             NotificationManager.error("", "Failed to create session", 3000);
//             return null;
//         }
//     };
//     useEffect(() => {
//         if (!propertyId || propertyId === "-1") return;
//         getOnboardSession();
//     }, [propertyId]);

//     const ClickGetStarted = async () => {
//         if (isCreatingSession) return;
//         try {
//             setIsCreatingSession(true);
//             const sessionId = await createOnboardSession();
//             if (sessionId) {
//                 setid(sessionId);
//                 setStep("businessProfile");
//             }
//         } catch (error) {
//             console.error("Failed to start onboarding", error);
//         } finally {
//             setIsCreatingSession(false);
//         }
//     };
//     const ClickEnd = () => setStep("thankyou");
//     const ClickAiVoice = () => {
//         setTemplateData(prev => ({
//             ...prev,
//             ...defaultWidgetSettings,
//         }));

//         setStep("aiVoice");
//         setIsSuccess(false);

//     };

//     const ClickEmailAssistant = () => {
//         setTemplateData(prev => ({
//             ...prev,
//             ...defaultWidgetSettings,
//         }));
//         setStep("emailAssistant");
//         setIsSuccess(false);
//     }
//     const ClickBooking = () => {
//         setStep("bookingAgent");
//         setIsSuccess(false);
//     }
//     const ClickProducts = () => {
//         setStep("availableProduct");
//         setIsSuccess(false);
//     }
//     const ClickSynxis = () => {
//         setStep("synxisIntegration");
//         setIsSuccess(false);
//     }
//     const ClickSyncSabre = () => {
//         setStep("syncHotel");
//         setIsSuccess(false);
//     }
//     const ClickHidestats = () => {
//         setStep("hidestate_topic");
//         setIsSuccess(false);
//     }
//     const createQuestionSetFromTemplate = async () => {
//         const templateFlow = dynamicList.find(
//             (flow) => flow.openAiAssistantId === templateData.dynamicFlowId
//         );

//         if (!templateFlow) return null;

//         const payload = {
//             GroupId: getGroupID(),
//             PropertyId: propertyId === "-1" ? null : propertyId,
//             Name: templateFlow.name,
//             Description: templateFlow.description || "",
//             Instructions: templateFlow.instructions || "",
//             AssistantInstructions: templateFlow.assistantInstructions || "",
//             Type: "DynamicConversationFlow",
//             Status: "Active",
//             IsGroupVisible: templateFlow.isGroupVisible ?? false,
//             OpenAiModel: templateFlow.openAiModel,
//             OpenAiReasoningEfforts: null,
//             OpenAiVerbosity: templateFlow.openAiVerbosity,
//             flowTrainingData: templateFlow.flowTrainingData,
//             flowInvokeApi: templateFlow.flowInvokeApi,
//             languageCode: locale,
//             Creator: "Wizard",
//             publishConversationFlow: false,
//         };

//         try {
//             const res = await AxiosAPI({
//                 method: "post",
//                 url: postAPI_Create_QuestionSet,
//                 data: payload,
//             });

//             return {
//                 flowId: res?.data?.id || null,
//                 assistantId: res?.data?.openAiAssistantId || null,
//             };

//         } catch (error) {
//             console.error("Failed to create Dynamic Conversation Flow", error);
//             return null;
//         }
//     };
//     const getSuccessMessage = () => {
//         switch (step) {
//             case "next":
//                 return "Web Widget created successfully";
//             case "aiVoice":
//                 return "Voice AI channel created successfully";
//             case "emailAssistant":
//                 return "AI Email Assistant created successfully";
//             default:
//                 return "Channel created successfully";
//         }
//     };

//     const handleSubmit = async () => {
//         setApiTemplate("processing");

//         let dynamicFlowIdToUse = templateData.dynamicFlowId;

//         const newFlowId = await createQuestionSetFromTemplate();

//         if (newFlowId) {
//             dynamicFlowIdToUse = newFlowId?.assistantId;
//             setTemplateData((prev) => ({
//                 ...prev,
//                 dynamicFlowId: newFlowId.assistantId,
//             }));
//         }

//         let payload = {
//             fromGroupId: templateData.fromGroupId,
//             fromPropertyId: templateData.fromPropertyId,
//             toPropertyId: templateData.toPropertyId,
//             toGroupId: templateData.toGroupId,
//             appearance: appearanceData,
//             dynamicFlowId: dynamicFlowIdToUse,
//         };

//         if (step === "bookingAgent") {
//             payload = {
//                 ...payload,
//                 isWeb: true,
//                 isMessengerX: true,
//                 isAssistantMenu: true,
//                 isFAQ: false,
//                 isMessengerGroupX: false,
//                 isAiVoice: false,
//                 isEmail: false,
//                 isConversationFlow: Boolean(dynamicFlowIdToUse),
//                 isHelpItem: templateData.isHelpItem,
//                 isForm: templateData.isForm,
//                 messengerTheme: templateData.messengerTheme,
//             };
//         }

//         if (step === "aiVoice") {
//             payload = {
//                 ...payload,
//                 isAiVoice: true,
//                 isConversationFlow: Boolean(dynamicFlowIdToUse),
//             };
//         }

//         if (step === "emailAssistant") {
//             payload = {
//                 ...payload,
//                 isEmail: true,
//                 isConversationFlow: Boolean(dynamicFlowIdToUse),
//             };
//         }
//         try {
//             const res = await AxiosAPI({
//                 method: "post",
//                 url: API_CopyTemplate_Integration,
//                 data: payload,
//             });
//             NotificationManager.success(
//                 "",
//                 getSuccessMessage(),
//                 5000
//             );

//             setIsSuccess(true);
//             if (step === "bookingAgent") {
//                 setBookingAgentCreated(true);
//                 setShowBookingConfig(true);
//                 const bookingPayload = {
//                     onboardSessionId: id,
//                     stepName: "booking-agent",
//                     status: "UpdatedOrCreated",
//                     creator: userName,
//                     modifiedBy: "Dashboard",
//                     bookingAgentConfig: {
//                         webWidgetIid: res?.data?.webWidgetId,
//                         chatbotIid: res?.data?.chatbotId,
//                         theme: templateData.messengerTheme,
//                         forms: templateData.isForm,
//                         webWidgetMenus: true,
//                         chatbotEnabled: true,
//                         defaultWelcomeMessage: true,
//                         dynamicConversationFlowId: dynamicFlowIdToUse,
//                         primaryColor: appearanceData.primaryColor,
//                         contrastTextColor: appearanceData.contrastColor,
//                         widgetOption: creationOption === 1 ? "CreateNew" : "UseExisting"
//                     }
//                 };

//                 console.log("StepCreate Payload:", bookingPayload);

//                 await createWizardSteps(bookingPayload);

//                 setHasChanged(false);

//                 await getWizardSteps(id);
//             }
//             if (step === "aiVoice") {

//                 setVoiceAgentId(res?.data?.voiceAgentId);

//                 const payload = {
//                     onboardSessionId: id,
//                     stepName: "voice-agent",
//                     status: "UpdatedOrCreated",
//                     creator: userName,
//                     modifiedBy: "Dashboard",

//                     voiceAgentConfig: {
//                         voiceEnabled: true,
//                         voiceIid: res?.data?.voiceAgentId,
//                         dynamicConversationFlowId: dynamicFlowIdToUse
//                     }
//                 };

//                 await createWizardSteps(payload);
//                 setHasChanged(false);
//                 await getWizardSteps(id);
//             }
//             if (step === "emailAssistant") {

//                 const emailId = res?.data?.emailAutomationId;
//                 setEmailIid(emailId);

//                 const payload = {
//                     onboardSessionId: id,
//                     stepName: "email-automation",
//                     status: "UpdatedOrCreated",
//                     creator: userName,
//                     modifiedBy: "Dashboard",
//                     emailAutomationConfig: {
//                         automationOption: emailAutomationOption === 1 ? "CreateNew" : "UseExisting",
//                         emailEnabled: true,
//                         dynamicConversationFlowId: dynamicFlowIdToUse,
//                         manifestDownloaded: false,
//                         emailIid: emailId
//                     }
//                 };

//                 await createWizardSteps(payload);

//                 await getWizardSteps(id);
//             }

//         } catch (error) {
//             console.error(error);
//             NotificationManager.error("", "Something went wrong", 3000);
//         }
//     };
//     const checkAndCompleteSession = async (steps) => {

//         const requiredSteps = [
//             "business-details",
//             "select-products",
//             "synxis-integration",
//             "sync-description",
//             "booking-agent",
//             "voice-agent",
//             "email-automation",
//             "insights"
//         ];

//         const stepMap = {};

//         steps.forEach(s => {
//             stepMap[s.stepName] = s.status;
//         });

//         const allStepsExist = requiredSteps.every(step => stepMap[step] !== undefined);

//         const allCompleted = requiredSteps.every(
//             step => stepMap[step] === "UpdatedOrCreated"
//         );

//         if (allStepsExist && allCompleted) {

//             try {

//                 await AxiosAPI({
//                     method: "put",
//                     url: `${putAPI_Update_OnboardSession}/${id}`,
//                     data: {
//                         id: id,
//                         sessionStatus: "Completed",
//                         modifiedBy: "Dashboard"
//                     }
//                 });
//                 setStep("thankyou")
//                 console.log("Session marked as Completed");

//             } catch (error) {
//                 console.error("Failed to update session status", error);
//             }

//         }
//     };

//     const handleNotNow = async () => {
//         await createWizardSteps({
//             onboardSessionId: id,
//             stepName: "booking-agent",
//             status: "Skipped",
//             creator: userName,
//             modifiedBy: "Dashboard",
//         });
//         ClickAiVoice()
//     };
//     useEffect(() => {
//         if (isUpdatedBookingAgent) {
//             setBookingAgentCreated(true)
//             setShowBookingConfig(true)
//         }
//     }, [isUpdatedBookingAgent])
//     const stepImages = {
//         intro: wizardIntro,
//         businessProfile: wizard,
//         availableProduct: wizard,
//         synxisIntegration: wizardIntro,
//         syncHotel: wizard,
//         bookingAgent: wizard,
//         aiVoice: wizardIntro,
//         emailAssistant: wizardIntro,
//         hidestate_topic: wizard,
//         thankyou: wizardIntro
//     };

//     const currentWizardImage = stepImages[step] || wizardIntro;

//     const Stepper = ({ currentStep, setStep }) => {
//         const currentIndex = STEPS.findIndex(s => s.key === currentStep);

//         return (
//             <div className="multi-step-wrapper">

//                 {STEPS.map((stepItem, index) => {
//                     const isActive = index === currentIndex;
//                     const isCompleted = index < currentIndex;
//                     const isUpdated =
//                         stepItem.key === "thankyou"
//                             ? step === "thankyou"
//                             : stepStatusMap[stepItem.key] === "UpdatedOrCreated";
//                     const handleClick = () => {
//                         if (isCompleted || isUpdated) {
//                             setStep(stepItem.key);
//                         }
//                     };

//                     return (
//                         <div
//                             key={stepItem.key}
//                             className={`step-item ${isCompleted ? "completed" : ""}`}
//                         >

//                             <div
//                                 className={`step-circle
//                                 ${isActive ? "active" : ""}
//                                 ${isCompleted ? "completed clickable" : ""}`}
//                                 onClick={handleClick}
//                             >
//                                 {isUpdated ? (
//                                     <FaCheck color="white" size={12} />
//                                 ) : (
//                                     index + 1
//                                 )}
//                             </div>
//                             <div className="step-label">
//                                 {stepItem.label}
//                             </div>
//                         </div>
//                     );
//                 })}
//             </div>
//         );
//     };

//     return (
//         <Fragment >
//             <style>{`
//              @keyframes spin {
//             100%{
//              transform: rotate(360deg);
//                 }
//             }
//             .spin {
//             animation: spin 1s linear infinite;
//                  }
//             `
//             }</style>
//             <Row className=" mb-2">
//                 <Colxx xxs="12">
//                     <CardTitle>
//                         <b>
//                             Set up channels effortlessly via the wizard
//                         </b>
//                         <br />
//                         Get started fast with wizards for Web Widget, Email Automation, and Voice AI—everything is fully editable afterwards.
//                     </CardTitle>
//                 </Colxx>
//             </Row>
//             {step && step !== "intro" && (
//                 <Row className="mb-3 mt-4">
//                     <Colxx xxs="12">
//                         <Stepper currentStep={step} setStep={setStep} />
//                     </Colxx>
//                 </Row>
//             )}

//             <Row>
//                 <Card className="wizard-card mt-4">
//                     <Row className="g-0">
//                         <Colxx md="4" sm="12" className="wizard-left">

//                             <img
//                                 src={currentWizardImage}
//                                 alt="Wizard"
//                                 className="wizard-image"
//                             />

//                         </Colxx>
//                         <Colxx md="8" sm="12" className="wizard-right-col">
//                             <div className="wizard-right-container">

//                                 {/* TOP CONTENT */}
//                                 <div className="wizard-content">
//                                     {/* {step !== "thankyou" && <img className="wizard-image"
//                                         src={sync_template}
//                                         alt="Sync"
//                                     />
//                                     } */}
//                                     {step === "intro" && (
//                                         <Fragment>
//                                             <Colxx sm={12} className="mb-2 mt-4 ml-2">
//                                                 <h5 className="mb-2">To unlock the full potential of AI, you can quickly set up the channels:</h5>
//                                                 <div className=" mt-4 mb-4" style={{ fontSize: '14px' }}>
//                                                     <p className="mt-2"><img src={widget} width={40} height={40} /> Booking Agent for website and booking engine</p>
//                                                     <p className="mt-2"><img src={voice} width={40} height={40} /> Voice Connect</p>
//                                                     <p className="mt-2"><img src={email_icon} width={40} height={40} /> Email Assistant</p>
//                                                     <p className="mt-2"><img src={social_icon} width={40} height={40} /> Social Connect</p>
//                                                 </div>

//                                                 <h6 className="mb-2 mt-4"><b>Save time by using wizards to setup channels for you. You can later change or customize every aspect you like.</b></h6>

//                                             </Colxx>
//                                             <Colxx xxs="12" className="text-right" style={{ marginTop: '80px' }}>
//                                                 <Button
//                                                     color="primary"
//                                                     size="xs"
//                                                     outline
//                                                     className="mr-1"
//                                                     onClick={ClickGetStarted}
//                                                     disabled={isCreatingSession}
//                                                 >
//                                                     {isCreatingSession ? (
//                                                         <>
//                                                             <FaSpinner className="spin mr-2" />
//                                                             Onboarding...
//                                                         </>
//                                                     ) : (
//                                                         "Get Started"
//                                                     )}
//                                                 </Button>
//                                             </Colxx>
//                                         </Fragment>
//                                     )}
//                                     {step === "businessProfile" && (
//                                         <BusinessProfile
//                                             propertyId={propertyId}
//                                             property={propertyData}
//                                             getdata={getWizardSteps}
//                                             stepCreate={createWizardSteps}
//                                             userName={userName}
//                                             id={id}
//                                             clickProducts={ClickProducts}
//                                             isSuccess={isSuccess}
//                                             setIsSuccess={setIsSuccess}
//                                             stepStatusMap={stepStatusMap}
//                                         />
//                                     )}
//                                     {step === "availableProduct" && (
//                                         <AvailableProduct
//                                             propertyId={propertyId}
//                                             property={propertyData}
//                                             getdata={getWizardSteps}
//                                             stepCreate={createWizardSteps}
//                                             clickEnd={ClickSynxis}
//                                             isSuccess={isSuccess}
//                                             setIsSuccess={setIsSuccess}
//                                             groupId={getGroupID()}
//                                             stepStatusMap={stepStatusMap}
//                                             userName={userName}
//                                             id={id}
//                                         />
//                                     )}
//                                     {/* ---------- Synxis Integration ---------- */}
//                                     {step === "synxisIntegration" && (
//                                         <SynXisIntegration
//                                             propertyId={propertyId}
//                                             clickEnd={ClickSyncSabre}
//                                             getdata={getWizardSteps}
//                                             stepStatusMap={stepStatusMap}
//                                             stepCreate={createWizardSteps}
//                                             userName={userName}
//                                             id={id}
//                                             setIsSuccess={setIsSuccess}
//                                             isSuccess={isSuccess}
//                                         />
//                                     )}
//                                     {step === "syncHotel" && (
//                                         <SyncRoom_Hotel
//                                             propertyId={propertyId}
//                                             locale={locale}
//                                             email={email}
//                                             getdata={getWizardSteps}
//                                             stepStatusMap={stepStatusMap}
//                                             stepCreate={createWizardSteps}
//                                             userName={userName}
//                                             id={id}
//                                             submit={handleAddDocument}
//                                             LoadData={LoadData}
//                                             hotelCode={propertyData?.providerPropertyId}
//                                             propertyLanguages={propertyLanguages}
//                                             synxisData={synxisData}
//                                             sabreIntegration={sabreIntegration}
//                                             clickEnd={ClickBooking}
//                                             setIsSuccess={setIsSuccess}
//                                             isSuccess={isSuccess}
//                                         />
//                                     )}
//                                     {/* ---------- WEB WIDGET SETUP ---------- */}
//                                     {step === "bookingAgent" && !showBookingConfig && !bookingAgentCreated && (

//                                         <Colxx sm={12} className="mb-4 ml-2">

//                                             <h5>Select Booking Agent Creation Option</h5>

//                                             <FormGroup className="mt-4">
//                                                 <CustomInput
//                                                     type="radio"
//                                                     id="createNew"
//                                                     value={1}
//                                                     label="Create New"
//                                                     checked={creationOption === 1}
//                                                     onChange={() => setCreationOption(1)}
//                                                 />
//                                             </FormGroup>

//                                             <FormGroup>
//                                                 <CustomInput
//                                                     type="radio"
//                                                     id="useExisting"
//                                                     value={2}
//                                                     label="Use Existing"
//                                                     checked={creationOption === 2}
//                                                     onChange={() => setCreationOption(2)}
//                                                 />
//                                             </FormGroup>

//                                             {creationOption && (
//                                                 <Button
//                                                     color="primary"
//                                                     size="xs"
//                                                     outline
//                                                     className="mt-3"
//                                                     onClick={() => setShowBookingConfig(true)}
//                                                 >
//                                                     Process...
//                                                 </Button>
//                                             )}

//                                         </Colxx>
//                                     )}
//                                     {step === "bookingAgent" && showBookingConfig && !bookingAgentCreated && (
//                                         <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: "10px" }}>
//                                             <Button
//                                                 color="secondary"
//                                                 outline
//                                                 size="xs"
//                                                 onClick={() => {
//                                                     setShowBookingConfig(false);
//                                                 }}
//                                             >
//                                                 Back
//                                             </Button>
//                                         </div>
//                                     )}
//                                     {step === "bookingAgent" && showBookingConfig && (
//                                         <Fragment>
//                                             <Colxx sm={12} className="mb-2 ml-2">
//                                                 <h5>Select your primary website/brand colors.</h5>
//                                                 <Row>
//                                                     <Colxx md={4}>
//                                                         <div>
//                                                             <div className='row mb-2 mt-2' onClick={(e) => { e.stopPropagation(); }}>
//                                                                 <div className='col-md-12 text-left' style={{ marginTop: '0.30rem' }}>
//                                                                     <span className='' style={{ fontSize: "14px" }}>Primary Color​</span>
//                                                                 </div>
//                                                                 <div className='col-md-12 mt-2'>
//                                                                     <InputGroup>
//                                                                         <Input
//                                                                             className=""
//                                                                             type="text"
//                                                                             onChange={(e) => {
//                                                                                 setAppearanceData({ ...appearanceData, primaryColor: e.target.value });
//                                                                                 setHasChanged(true);
//                                                                             }}
//                                                                             value={appearanceData.primaryColor}
//                                                                         />
//                                                                         <InputGroupAddon addonType="append">
//                                                                             <InputGroupText onClick={() => {
//                                                                                 setEditMode({ ...iseditMode, primaryColor: !iseditMode.primaryColor });
//                                                                                 setHasChanged(true);
//                                                                             }}
//                                                                                 className="color-square" style={setBackGroundColor(appearanceData.primaryColor)}></InputGroupText>
//                                                                         </InputGroupAddon>
//                                                                     </InputGroup>
//                                                                 </div>
//                                                             </div>
//                                                         </div>
//                                                         {iseditMode.primaryColor && <div className='parent-div'>
//                                                             <div className='cover ' onClick={(e) => { e.stopPropagation(); }}>
//                                                                 <ChromePicker disableAlpha={true} className='ml-2'
//                                                                     style={{ width: '200px' }}
//                                                                     color={appearanceData.primaryColor}
//                                                                     onChangeComplete={(e) => {
//                                                                         if (edit) {
//                                                                             setAppearanceData({ ...appearanceData, primaryColor: e.hex });
//                                                                             setEditMode({ ...iseditMode, primaryColor: false });
//                                                                         } else setError(true);
//                                                                     }}
//                                                                 />
//                                                             </div>
//                                                         </div>}
//                                                     </Colxx>
//                                                     <Colxx sm={4} className="mt-3 ml-3">
//                                                         <Label style={{ fontSize: "14px" }}>Contrast Text Color</Label>
//                                                         <div className="d-flex mt-2">
//                                                             <CustomInput
//                                                                 type="radio"
//                                                                 id="white"
//                                                                 value={"white"}
//                                                                 onChange={(e) => {
//                                                                     setAppearanceData({ ...appearanceData, contrastColor: e.target.value });
//                                                                     setHasChanged(true);
//                                                                 }}
//                                                                 checked={appearanceData.contrastColor === "white" ? true : false}
//                                                             >White</CustomInput>
//                                                             <CustomInput
//                                                                 className="ml-2"
//                                                                 type="radio"
//                                                                 id="black"
//                                                                 value={"black"}
//                                                                 onChange={(e) => {
//                                                                     setAppearanceData({ ...appearanceData, contrastColor: e.target.value });
//                                                                     setHasChanged(true);
//                                                                 }}
//                                                                 checked={appearanceData.contrastColor === "black" ? true : false}
//                                                             >Black</CustomInput>
//                                                         </div>
//                                                     </Colxx>
//                                                 </Row>
//                                                 <h5 className="mb-2">Setup Web Widget</h5>

//                                                 <FormGroup className="mt-4">
//                                                     <CustomInput
//                                                         type="checkbox"
//                                                         id="isWeb"
//                                                         checked={true}
//                                                         disabled
//                                                         title=" This option is required for Web Widget setup and cannot be disabled."
//                                                     >
//                                                         Chatbot for website
//                                                     </CustomInput>
//                                                 </FormGroup>

//                                                 <FormGroup>
//                                                     <CustomInput
//                                                         type="checkbox"
//                                                         id="isMessengerX"
//                                                         checked={true}
//                                                         disabled
//                                                         title=" This option is required for Web Widget setup and cannot be disabled."
//                                                     >
//                                                         Web Widget for website
//                                                     </CustomInput>
//                                                 </FormGroup>

//                                                 <FormGroup>
//                                                     <CustomInput
//                                                         type="checkbox"
//                                                         id="isAssistantMenu"
//                                                         checked={true}
//                                                         disabled
//                                                         title=" This option is required for Web Widget setup and cannot be disabled."
//                                                     >
//                                                         Default welcome message
//                                                     </CustomInput>
//                                                 </FormGroup>

//                                             </Colxx>

//                                             <Colxx sm={12} className="mb-2">
//                                                 <h5>Select Theme</h5>
//                                                 <Input className="w-80 mt-2 input_sty"
//                                                     type="select"
//                                                     name="messengerTheme"
//                                                     value={templateData.messengerTheme}
//                                                     onChange={(e) => {
//                                                         updateTemplateData("messengerTheme", e.target.value);
//                                                         setHasChanged(true);
//                                                     }}
//                                                 >
//                                                     <option value='WebWidgetMenus' >Web Widget with Menus (Standard Size)</option>
//                                                     <option value='ChatSuggestions'>Web Widget with Suggested Questions</option>
//                                                 </Input>
//                                             </Colxx>
//                                             <Colxx sm={12} className="mb-2 mt-2">
//                                                 <Label style={{ fontSize: "14px" }}>Select the templetes you want to copy</Label>
//                                                 <FormGroup>
//                                                     <CustomInput
//                                                         type="checkbox"
//                                                         id="isHelpItem"
//                                                         // onChange={(e) => setTemplateData({ ...templateData, isHelpItem: e.target.checked })}
//                                                         onChange={(e) => {
//                                                             updateTemplateData("isHelpItem", e.target.checked)
//                                                             setHasChanged(true)
//                                                         }}
//                                                         checked={templateData.isHelpItem}
//                                                     >Common help items</CustomInput>
//                                                 </FormGroup>
//                                                 <FormGroup>
//                                                     <CustomInput
//                                                         type="checkbox"
//                                                         id="isForm"
//                                                         onChange={(e) => {
//                                                             updateTemplateData("isForm", e.target.checked)
//                                                             setHasChanged(true)
//                                                         }}
//                                                         checked={templateData.isForm}
//                                                     >Common Forms</CustomInput>
//                                                 </FormGroup>
//                                             </Colxx>


//                                             {assistantList && assistantList.length > 0 && (
//                                                 <Colxx xxs="12" className="mb-2">
//                                                     <Label style={{ fontSize: "14px" }}>Dynamic Conversation Flow</Label>
//                                                     <Input className="w-80  input_sty"
//                                                         type="select"
//                                                         name="dynamicConversationFlow"
//                                                         placeholder="Dynamic Conversation Flow"
//                                                         value={templateData.dynamicFlowId || ""}
//                                                         onChange={(e) => {
//                                                             updateTemplateData("dynamicFlowId", e.target.value || null)
//                                                             setHasChanged(true)
//                                                         }}
//                                                     >
//                                                         <option value="">
//                                                             Select a Dynamic Conversation Flow
//                                                         </option>
//                                                         {assistantList.map((assist, index) => (
//                                                             <option key={index} value={assist.openAiAssistantId}>
//                                                                 {assist.name} ({assist.openAiAssistantId})
//                                                             </option>
//                                                         ))}
//                                                     </Input>
//                                                 </Colxx>
//                                             )}


//                                             <Colxx xxs="12" className="mb-4 text-right" style={{ marginTop: '10px' }}>
//                                                 {isUpdatedBookingAgent && !hasChanged ?
//                                                     <Button
//                                                         color="primary"
//                                                         size="xs"
//                                                         outline
//                                                         className=" mr-1"
//                                                         onClick={ClickAiVoice}
//                                                     >
//                                                         Next
//                                                     </Button>
//                                                     :
//                                                     <div className="widget-wrap">
//                                                         <Button
//                                                             color="primary"
//                                                             size="xs"
//                                                             outline
//                                                             className=" mr-1"
//                                                             onClick={handleSubmit}
//                                                         >
//                                                             Create Web Widget
//                                                         </Button>
//                                                         <h6
//                                                             style={{ display: 'flex' }}
//                                                             className="ml-4 not-now"
//                                                             onClick={handleNotNow}
//                                                         >
//                                                             Not Now <svg className='not-now' width="60" height="20" viewBox="70 15 40 20" xmlns="http://www.w3.org/2000/svg">
//                                                                 <path d="M60 25 H100 L90 15 M100 25 L90 35"
//                                                                     fill="none"
//                                                                     stroke="grey"
//                                                                     stroke-width="2"
//                                                                     stroke-linecap="round"
//                                                                     stroke-linejoin="round" />
//                                                             </svg>

//                                                         </h6>

//                                                     </div>
//                                                 }
//                                             </Colxx>
//                                         </Fragment>
//                                     )}

//                                     {/* ---------- AI VOICE STEP ---------- */}
//                                     {step === "aiVoice" && (
//                                         <AiVoiceChannel
//                                             stepStatusMap={stepStatusMap}
//                                             stepCreate={createWizardSteps}
//                                             userName={userName}
//                                             id={id}
//                                             templateData={templateData}
//                                             updateTemplateData={updateTemplateData}
//                                             assistantList={assistantList}
//                                             clickAiEmail={ClickEmailAssistant}
//                                             submit={handleSubmit}
//                                             isSuccess={isSuccess}
//                                         />
//                                     )}

//                                     {/* ---------- EMAIL ASSISTANT STEP ---------- */}
//                                     {step === "emailAssistant" && (
//                                         <AiEmailAssistant
//                                             stepStatusMap={stepStatusMap}
//                                             userName={userName}
//                                             id={id}
//                                             templateData={templateData}
//                                             updateTemplateData={updateTemplateData}
//                                             stepCreate={createWizardSteps}
//                                             assistantList={assistantList}
//                                             clickBusiness={ClickHidestats}
//                                             submit={handleSubmit}
//                                             isSuccess={isSuccess}
//                                             emailAutomationOption={emailAutomationOption}
//                                             setEmailAutomationOption={setEmailAutomationOption}
//                                         />
//                                     )}

//                                     {step === "hidestate_topic" && (
//                                         <HideStat_topic
//                                             propertyId={propertyId}
//                                             property={propertyData}
//                                             stepCreate={createWizardSteps}
//                                             getdata={getWizardSteps}
//                                             stepStatusMap={stepStatusMap}
//                                             userName={userName}
//                                             id={id}
//                                             clickEnd={ClickEnd}
//                                             isSuccess={isSuccess}
//                                             setIsSuccess={setIsSuccess}
//                                         />
//                                     )}
//                                     {step === "thankyou" && (
//                                         <div className="wizard-summary mb-4 ml-4">

//                                             <h1 className="text-center">Thank You!</h1>

//                                         </div>
//                                     )}

//                                 </div>
//                             </div>
//                         </Colxx>
//                     </Row>
//                 </Card>
//             </Row >
//         </Fragment >
//     );
// }

// const mapStateToProps = ({ settings }) => {
//     const { propertyId, locale, email, userName } = settings;
//     return {
//         propertyId,
//         locale,
//         email,
//         userName
//     };
// };

// export default injectIntl(connect(mapStateToProps, {})(Templates));